import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'

import { formatPrice } from '../../../../utils/common'
import styles from './InvoiceFollowUpDialog.module.scss'

const InvoiceFollowUpDialog = ({
  isOpen,
  onClose,
  subsidiaryInvoiceId,
  displayId,
  hotelName,
  totalAmountDue,
  balanceRemaining,
  balanceState,
  dueDate,
  agingDays,
  entries,
  isLoading,
  isSaving,
  error,
  loadEntries,
  addEntry
}) => {
  const [draftText, setDraftText] = useState('')
  const hasRequestedForOpenRef = useRef(false)

  useEffect(() => {
    if (!isOpen) {
      hasRequestedForOpenRef.current = false
      return
    }

    if (hasRequestedForOpenRef.current) {
      return
    }

    hasRequestedForOpenRef.current = true
    loadEntries({ force: true })
  }, [isOpen, loadEntries])

  if (!isOpen) {
    return null
  }

  const handleAddNote = async () => {
    const saved = await addEntry(draftText)
    if (saved) {
      setDraftText('')
    }
  }

  return (
    <ConfirmationDialog
      title={`Follow-up notes — Invoice #${subsidiaryInvoiceId}`}
      onClose={onClose}
      hasConfirmButton={false}
      maxWidth={640}
      allowOverflow
      contentPadding="0"
    >
      <div className={styles.metaGrid}>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Hotel</span>
          <span className={styles.metaValue}>
            #{displayId} {hotelName}
          </span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Invoice / overdue</span>
          <span className={styles.metaValue}>
            {formatPrice(totalAmountDue)} / {formatPrice(balanceRemaining)} • {balanceState}
          </span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Due / aging</span>
          <span className={styles.metaValue}>
            {moment(dueDate).format('MMM DD, YYYY')} ({agingDays} days)
          </span>
        </div>
      </div>

      <div className={styles.historyPanel}>
        {isLoading && <div className={styles.statusText}>Loading notes...</div>}
        {!isLoading && entries.length === 0 && (
          <div className={styles.statusText}>No follow-up notes yet.</div>
        )}
        {entries.map(entry => (
          <div key={entry.id} className={styles.historyEntry}>
            <div className={styles.historyMeta}>
              {moment(entry.addedOn).format('MMM DD, YYYY HH:mm')}
              {entry.addedByFullName ? ` • ${entry.addedByFullName}` : ''}
            </div>
            <div className={styles.historyText}>{entry.text}</div>
          </div>
        ))}
      </div>

      <div className={styles.composer}>
        <textarea
          className={styles.noteInput}
          value={draftText}
          onChange={e => setDraftText(e.target.value)}
          placeholder="Add follow-up note (e.g. customer promised to pay, check sent)..."
          disabled={isSaving}
        />
        <div className={styles.composerActions}>
          <button
            type="button"
            className={styles.addButton}
            onClick={handleAddNote}
            disabled={isSaving || !draftText.trim()}
          >
            {isSaving ? 'Saving...' : 'Add note'}
          </button>
        </div>
        {error && <div className={styles.error}>{error}</div>}
      </div>
    </ConfirmationDialog>
  )
}

export default InvoiceFollowUpDialog
